<script lang="ts">
  import LyHeader from './layout/LyHeader.svelte';
  import LyMain from './layout/LyMain.svelte';
  import LyFooter from './layout/LyFooter.svelte';
  import LySidebar from './layout/LySidebar.svelte';
</script>

<div class="LayoutPage">
  <div class="LayoutFrontend">
    <LySidebar />
    <div class="LayoutContent">
      <div class="LayoutHeaderWrapper">
        <LyHeader />
      </div>
      <div class="LayoutMainWrapper">
        <LyMain />
      </div>
    </div>
    <LyFooter />
  </div>
</div>

<style lang="scss">
  @use '../styles/mixins';
  @use '../styles/defintions';

  .LayoutPage {
    position: relative;
    padding: 0;

    @include mixins.greaterSmall() {
      padding: 2vw 2vw 5rem;
    }

    @include mixins.greaterLarge() {
      padding-top: var(--outset-abs-doubled);
    }

    .LayoutFrontend {
      --frontend-abs-out: calc(var(--inset-abs) * 2);
      --frontend-abs-left: calc(var(--content-sidebar-padding-left) + var(--inset-abs));
      position: relative;
      margin: 0 auto;
      max-width: #{defintions.$wrapperWidth};

      .LayoutContent {
        position: relative;
        z-index: 5;
        top: auto;
        right: auto;
        bottom: auto;
        left: auto;
        width: auto;
        height: auto;
        background: transparent;
        border: none;
        border-radius: 0;
        box-shadow: none;

        @include mixins.greaterLarge() {
          top: var(--outset-abs-doubled);
          left: calc(var(--sidebar-width) - var(--content-sidebar-padding-left));
          width: calc(var(--content-width) + var(--content-sidebar-padding-left));
          border: var(--border-basic);
          border-radius: var(--border-radius);
          box-shadow: var(--box-shadow-basic);
          background: var(--layout-background-little-main);
        }
      }

      .LayoutHeaderWrapper {
        background: transparent;
        padding: var(--inset-abs) 2vw;
        margin-top: 0;
        border: none;
        border-radius: 0;
        box-shadow: none;

        @include mixins.greaterSmall() {
          padding: var(--inset-abs);
          background: var(--layout-background);
          margin-top: var(--inset-abs);
          border: var(--border-basic);
          border-radius: var(--border-radius);
          box-shadow: var(--box-shadow-basic);
        }

        @include mixins.greaterLarge() {
          padding-right: var(--frontend-abs-out);
          padding-left: var(--frontend-abs-left);
          margin-top: 0;
          border: none;
          box-shadow: none;
        }
      }

      .LayoutMainWrapper {
        background: transparent;
        padding: var(--inset-abs) 2vw;
        margin-top: 0;
        border: none;
        border-radius: 0;
        box-shadow: none;

        @include mixins.greaterSmall() {
          background: var(--layout-background-little-main);
          padding: var(--frontend-abs-out);
          box-shadow: var(--box-shadow-basic);
          margin-top: var(--inset-abs);
          border: var(--border-basic);
          border-radius: var(--border-radius);
        }

        @include mixins.greaterLarge() {
          padding-top: var(--inset-abs);
          padding-left: var(--frontend-abs-left);
          margin-top: 0;
          box-shadow: 0 5px 10px inset rgba(0, 0, 0, 0.1);
          border-radius: 0;
        }
      }
    }
  }
</style>
